import {
  createSuccessType,
  createSubmitType,
  createErrorType,
  createFetchType,
  createDeleteType,
  createLoadingType,
} from '../actionHelpers';

// Create Application Type
export const APPLICATION_TYPE_SCOPE = 'APPLICATION_TYPE';
export const APPLICATION_TYPE_SETUP = createSubmitType(APPLICATION_TYPE_SCOPE);
export const APPLICATION_TYPE_SETUP_SUCCESS = createSuccessType(
  APPLICATION_TYPE_SCOPE,
);
export const APPLICATION_TYPE_SETUP_ERROR = createErrorType(
  APPLICATION_TYPE_SCOPE,
);
export const APPLICATION_TYPE_SETUP_LOADING = createLoadingType(
  APPLICATION_TYPE_SCOPE,
);

// Create Application Account Type
export const CREATE_ACCOUNT_TYPE_SCOPE = 'CREATE_ACCOUNT_TYPE';
export const CREATE_ACCOUNT_TYPE = createSubmitType(CREATE_ACCOUNT_TYPE_SCOPE);
export const CREATE_ACCOUNT_TYPE_SUCCESS = createSuccessType(
  CREATE_ACCOUNT_TYPE_SCOPE,
);
export const CREATE_ACCOUNT_TYPE_ERROR = createErrorType(
  CREATE_ACCOUNT_TYPE_SCOPE,
);
export const CREATE_ACCOUNT_TYPE_LOADING = createLoadingType(
  CREATE_ACCOUNT_TYPE_SCOPE,
);

// Patch Application Account Type
export const PATCH_ACCOUNT_TYPE_SCOPE = 'PATCH_ACCOUNT_TYPE';
export const PATCH_ACCOUNT_TYPE = createSubmitType(PATCH_ACCOUNT_TYPE_SCOPE);
export const PATCH_ACCOUNT_TYPE_SUCCESS = createSuccessType(
  PATCH_ACCOUNT_TYPE_SCOPE,
);
export const PATCH_ACCOUNT_TYPE_ERROR = createErrorType(
  PATCH_ACCOUNT_TYPE_SCOPE,
);
export const PATCH_ACCOUNT_TYPE_LOADING = createLoadingType(
  PATCH_ACCOUNT_TYPE_SCOPE,
);

// Create and Control application onboarding Menu and Step
export const APPLICATION_ONBOARDING_SCOPE = 'APPLICATION_ONBOARDING';
export const APPLICATION_ONBOARDING_SETUP = createSubmitType(
  APPLICATION_ONBOARDING_SCOPE,
);
export const APPLICATION_ONBOARDING_SETUP_SUCCESS = createSuccessType(
  APPLICATION_ONBOARDING_SCOPE,
);
export const APPLICATION_ONBOARDING_SETUP_ERROR = createErrorType(
  APPLICATION_ONBOARDING_SCOPE,
);

// Get Application
export const GET_APPLICATION_SCOPE = 'GET_APPLICATION';
export const GET_APPLICATION = createFetchType(GET_APPLICATION_SCOPE);
export const GET_APPLICATION_SUCCESS = createSuccessType(GET_APPLICATION_SCOPE);
export const GET_APPLICATION_ERROR = createErrorType(GET_APPLICATION_SCOPE);
export const GET_APPLICATION_LOADING = createLoadingType(GET_APPLICATION_SCOPE);

// Delete Application
export const DELETE_APPLICATION_SCOPE = 'DELETE_APPLICATION';
export const DELETE_APPLICATION = createDeleteType(DELETE_APPLICATION_SCOPE);
export const DELETE_APPLICATION_SUCCESS = createSuccessType(
  DELETE_APPLICATION_SCOPE,
);
export const DELETE_APPLICATION_ERROR = createErrorType(
  DELETE_APPLICATION_SCOPE,
);

// Create Application Step
export const CREATE_APPLICATION_STEP_SCOPE = 'CREATE_APPLICATION_STEP_SCOPE';
export const CREATE_APPLICATION_STEP = createSubmitType(
  CREATE_APPLICATION_STEP_SCOPE,
);
export const CREATE_APPLICATION_STEP_SUCCESS = createSuccessType(
  CREATE_APPLICATION_STEP_SCOPE,
);
export const CREATE_APPLICATION_STEP_ERROR = createErrorType(
  CREATE_APPLICATION_STEP_SCOPE,
);
export const CREATE_APPLICATION_STEP_LOADING = createLoadingType(
  CREATE_APPLICATION_STEP_SCOPE,
);

export const RESET_APPLICATION = 'RESET_APPLICATION';

// Complete application
const COMPLETE_APPLICATION_SCOPE = 'COMPLETE_APPLICATION';
export const COMPLETE_APPLICATION = createSubmitType(
  COMPLETE_APPLICATION_SCOPE,
);
export const COMPLETE_APPLICATION_SUCCESS = createSuccessType(
  COMPLETE_APPLICATION_SCOPE,
);
export const COMPLETE_APPLICATION_ERROR = createErrorType(
  COMPLETE_APPLICATION_SCOPE,
);

export const COMPLETE_APPLICATION_LOADING = createLoadingType(
  COMPLETE_APPLICATION_SCOPE,
);

// Create Application
export const CREATE_APPLICATION_SCOPE = 'CREATE_APPLICATION_SCOPE';
export const CREATE_APPLICATION = createSubmitType(CREATE_APPLICATION_SCOPE);
export const CREATE_APPLICATION_SUCCESS = createSuccessType(
  CREATE_APPLICATION_SCOPE,
);
export const CREATE_APPLICATION_ERROR = createErrorType(
  CREATE_APPLICATION_SCOPE,
);
export const CREATE_APPLICATION_LOADING = createLoadingType(
  CREATE_APPLICATION_SCOPE,
);

// Upgrade Application
export const UPGRADE_APPLICATION_SCOPE = 'UPGRADE_APPLICATION_SCOPE';
export const UPGRADE_APPLICATION = createSubmitType(UPGRADE_APPLICATION_SCOPE);
export const UPGRADE_APPLICATION_SUCCESS = createSuccessType(
  UPGRADE_APPLICATION_SCOPE,
);
export const UPGRADE_APPLICATION_ERROR = createErrorType(
  UPGRADE_APPLICATION_SCOPE,
);
export const UPGRADE_APPLICATION_LOADING = createLoadingType(
  UPGRADE_APPLICATION_SCOPE,
);
